import {FC, SVGProps} from 'react';

export const FnsPendingEnvelopeIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="200" height="154" viewBox="0 0 200 154" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
		<path
			d="M101.082 42.0947H0V110.011H101.082V42.0947Z"
			fill="#F3F3F3"
			stroke="black"
			strokeWidth="2"
			strokeMiterlimit="10"
		/>
		<path d="M64.1484 78.1777L101.144 109.39" stroke="black" strokeWidth="2" strokeLinejoin="round" />
		<path d="M0 109.269L36.8448 78.1777" stroke="black" strokeWidth="2" strokeLinejoin="round" />
		<path d="M50.5462 92.5508L0 42.0947H101.082L50.5462 92.5508Z" stroke="black" strokeWidth="2" strokeLinejoin="round" />
		<path
			d="M136.694 50.6041L200 1L0 41.4631H101.864V110.151H0L162.454 152.308L124.166 90.8767L178.09 69.3071L136.694 50.6041Z"
			fill="black"
		/>
		<path
			d="M0 41.8439L199.92 1L136.614 50.6041L178.009 69.3071L124.085 90.8767L162.373 152.308L0.0200351 109.78"
			stroke="black"
			strokeWidth="2"
			strokeLinejoin="round"
		/>
	</svg>
);
